import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import routes from '../routes/routes'
import locationTypeService from '../services/locationType.service'
import locationTypeApi, { LocationTypeData } from '../apis/locationType.api'
import locationApi, { LocationCreateRequest } from '../apis/location.api'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import Card from '../components/Card'
import CardButton from '../components/CardButton'
import Row from '../components/Row/Row'
import InputText from '../components/InputText'
import Select from '../components/Select'
import PageHeading from '../components/PageHeading'

interface LocationCreateProps extends RouteComponentProps {}

interface LocationCreateState {
  name: string
  type: string
  capacity: string
  types: LocationTypeData[]
}

class LocationCreate
  extends Component<LocationCreateProps, LocationCreateState> {
  constructor (props: LocationCreateProps) {
    super(props)
    this.state = {
      name: '',
      type: '',
      capacity: '',
      types: []
    }
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleCreateClick = this.handleCreateClick.bind(this)
  }

  get typeSelectOptions () {
    return locationTypeService.selectOptions(this.state.types)
  }

  handleInputChange (name: string, value: string) {
    if (name === 'name') this.setState({ name: value })
    if (name === 'type') this.setState({ type: value })
    if (name === 'capacity') this.setState({ capacity: value })
  }

  handleCreateClick () {
    const { name, type, capacity } = this.state
    const payload: LocationCreateRequest = {}
    if (name) payload.location = name
    if (type) payload.locationType = Number(type)
    if (capacity) payload.capacity = Number(capacity)
    locationApi.create(payload, location => {
      if (!location) return
      this.props.history.push(routes.locations)
    })
  }

  listTypes () {
    locationTypeApi.list(types => {
      if (!types) return
      this.setState({ types })
    })
  }

  componentDidMount () {
    this.listTypes()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="oneThird">
          <Card>
            <PageHeading
              text={i18n("Create Location")}
              doc='locations-create-location' />
            <Row column={1}>
              <InputText
                name="name"
                value={this.state.name}
                label={i18n("Location")}
                onChange={this.handleInputChange} />
              <Select
                name="type"
                value={this.state.type}
                options={this.typeSelectOptions}
                label={i18n("Location type")}
                onChange={this.handleInputChange} />
              <InputText
                name="capacity"
                value={this.state.capacity}
                label={i18n("Capacity")}
                onChange={this.handleInputChange} />
            </Row>
            <CardButton
              proceedText={i18n("Create")}
              cancelText={i18n("Cancel")}
              onProceedClick={this.handleCreateClick} />
          </Card>
        </ContentMain>
      </ContentLayout>
    )
  }
}

export default withRouter(LocationCreate)
